import { ASSET_MANAGEMENT_GET_FORM_DATA, ASSET_MANAGEMENT_GET_BY_ID, FORMLIST_ADD_DATA, FORMLIST_UPDATE_DATA, FORMLIST_GET_BY_ID, FORMLIST_UPDATE_STATUS,} from "./Constants";

// GET form/allform
const loadAssetManagementGetFormDataRequest = () => ({
    type: ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_LOAD
})
const setAssetManagementGetFormDataSuccess = (data) => ({
    type: ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_SUCCESS,
    data
})
const setAssetManagementGetFormDataFail = (error) => ({
    type: ASSET_MANAGEMENT_GET_FORM_DATA.ASSET_MANAGEMENT_GET_FORM_DATA_FAIL,
    error
})

// GET form/formDataAllActiveStores/:form_id
const loadAssetManagementGetByIdRequest = (form_id) => ({
    type: ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_LOAD,
    form_id
})
const setAssetManagementGetByIdSuccess = (data) => ({
    type: ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_SUCCESS,
    data
})
const setAssetManagementGetByIdFail = (error) => ({
    type: ASSET_MANAGEMENT_GET_BY_ID.ASSET_MANAGEMENT_GET_BY_ID_FAIL,
    error
})

// GET form
const loadFormGetByIdRequest = (form_id) => ({
    type: FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_LOAD,
    form_id
})
const setFormGetByIdSuccess = (data) => ({
    type: FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_SUCCESS,
    data
})
const setFormGetByIdFail = (error) => ({
    type: FORMLIST_GET_BY_ID.FORMLIST_GET_BY_ID_FAIL,
    error
})

// add form
const loadFormAddDataRequest = (data) => ({
    type: FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_LOAD,
    data
})
const setFormAddDataSuccess = (data) => ({
    type: FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_SUCCESS,
    data
})
const setFormAddDataFail = (error) => ({
    type: FORMLIST_ADD_DATA.FORMLIST_ADD_DATA_FAIL,
    error
})

// edit form
const loadFormUpdateDataRequest = (form_id, data) => ({
    type: FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_LOAD,
    form_id,
    data
})
const setFormUpdateDataSuccess = (data) => ({
    type: FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_SUCCESS,
    data
})
const setFormUpdateDataFail = (error) => ({
    type: FORMLIST_UPDATE_DATA.FORMLIST_UPDATE_DATA_FAIL,
    error
})

// toggle form status
const loadFormUpdateStatusRequest = (form_id, data) => ({
    type: FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_LOAD,
    form_id,
    data
})
const setFormUpdateStatusSuccess = (data) => ({
    type: FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_SUCCESS,
    data
})
const setFormUpdateStatusFail = (error) => ({
    type: FORMLIST_UPDATE_STATUS.FORMLIST_UPDATE_STATUS_FAIL,
    error
})

export {
    loadAssetManagementGetFormDataRequest, setAssetManagementGetFormDataSuccess, setAssetManagementGetFormDataFail,
    loadAssetManagementGetByIdRequest, setAssetManagementGetByIdSuccess, setAssetManagementGetByIdFail,
    loadFormAddDataRequest, setFormAddDataSuccess,setFormAddDataFail,
    loadFormUpdateDataRequest, setFormUpdateDataSuccess, setFormUpdateDataFail,
    loadFormGetByIdRequest, setFormGetByIdSuccess, setFormGetByIdFail,
    loadFormUpdateStatusRequest, setFormUpdateStatusFail, setFormUpdateStatusSuccess,
}